// extracted by mini-css-extract-plugin
export var menu = "Menu-module--menu--3wcqw";
export var collpasedMenuList = "Menu-module--collpasedMenuList--3iDMN";
export var menuList = "Menu-module--menuList--3C-pY";
export var menuItemSelected = "Menu-module--menuItemSelected--EpCUo";
export var form = "Menu-module--form--14gJE";
export var visibleForm = "Menu-module--visibleForm--2N5p-";
export var invisibleForm = "Menu-module--invisibleForm--38yrV";
export var navbar = "Menu-module--navbar--3SMVC";
export var pageTitle = "Menu-module--pageTitle--1b52y";